import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { HeadlineS } from '#src/atoms/typography/index.tsx';

import type { Props as TransferProps } from './Transfer/index.tsx';
import { Transfer } from './Transfer/index.tsx';

type Props = {
  club: {
    displayName: string;
    slug: string;
    pictureUrl: string | null;
    code: string | null;
  };
  transfers: TransferProps['transfer'][];
};

export const Transfers = ({ club, transfers }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Team.Transfer.teamTransfers"
            defaultMessage="{team} transfers"
            values={{ team: club.displayName }}
          />
        </HeadlineS>
        {transfers.map(transfer => (
          <Transfer key={transfer.id} transfer={transfer} club={club} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
